<template>
  <v-card text :height="height">
    <v-app-bar absolute elevate-on-scroll color="white">
      <v-toolbar-title class="hidden-sm-and-down ml-5">
        Company Information
      </v-toolbar-title>
    </v-app-bar>

    <v-card-text pt-5>
      <v-container grid-list-md pt-5>
        <v-layout wrap>
          <v-flex xs12 md8>
            <v-flex xs12>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.name"
                    @keyup.enter="save"
                    label="Company Name"
                    ref="focusName"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model="editedItem.address"
                @keyup.enter="save"
                label="Address"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-layout wrap>
                <v-flex xs10 md5>
                  <v-text-field
                    v-model="editedItem.city"
                    @keyup.enter="save"
                    label="City"
                  ></v-text-field>
                </v-flex>
                <v-flex xs2 md2>
                  <v-text-field
                    v-model="editedItem.state"
                    @keyup.enter="save"
                    label="ST"
                    v-mask="mask.state"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md5>
                  <v-text-field
                    v-model="editedItem.zip"
                    @keyup.enter="save"
                    label="Zipcode"
                    v-mask="mask.zip"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md8>
                  <v-text-field
                    v-model="editedItem.email"
                    @keyup.enter="save"
                    label="Default Email Address"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    v-model="editedItem.phone"
                    @:keyup.enter="save"
                    label="Phone Number"
                    v-mask="mask.phone"
                    return-masked-value
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  Email Text
                  <tiptap-vuetify
                    v-model="editedItem.emailHtml"
                    :extensions="extensions"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
          </v-flex>
          <v-flex
            xs12
            md4
            class="text-xs-center text-sm-center text-md-center text-lg-center"
          >
            <v-flex xs12 text-xs-center>
              <v-layout wrap>
                <v-flex xs12 class="font-weight-black">
                  Logo
                </v-flex>
                <v-flex xs12>
                  <croppa
                    v-model="croppa"
                    :initial-image="initialImage"
                    :placeholder-font-size="14"
                    :prevent-white-space="true"
                    :disable-drag-and-drop="false"
                    :width="300"
                    :height="300"
                    :zoom-speed="7"
                  >
                  </croppa>
                </v-flex>
                <v-flex xs12>
                  <v-btn
                    text
                    icon
                    color="primary"
                    small
                    @click="croppa.rotate(-1)"
                  >
                    <v-icon>mdi-rotate-left</v-icon>
                  </v-btn>
                  <v-btn
                    text
                    icon
                    color="primary"
                    small
                    @click="croppa.rotate()"
                  >
                    <v-icon>mdi-rotate-right</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex xs12 text-xs-center>
                  <v-layout wrap>
                    <v-flex xs12 class="font-weight-black">
                      Default Signature
                    </v-flex>
                    <v-flex xs12>
                      <croppa
                        v-model="croppa1"
                        :initial-image="initialSign"
                        :placeholder-font-size="14"
                        :prevent-white-space="true"
                        :disable-drag-and-drop="false"
                        :width="280"
                        :height="100"
                        :zoom-speed="7"
                      >
                      </croppa>
                    </v-flex>
                    <v-flex xs12>
                      <v-btn
                        text
                        icon
                        color="primary"
                        small
                        @click="croppa.rotate(-1)"
                      >
                        <v-icon>mdi-rotate-left</v-icon>
                      </v-btn>
                      <v-btn
                        text
                        icon
                        color="primary"
                        small
                        @click="croppa.rotate()"
                      >
                        <v-icon>mdi-rotate-right</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="blue darken-1"
        dark
        transition="fade-transition"
        @click.native="save"
      >
        Save
      </v-btn>
    </v-card-actions>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line="true"
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn dark text @click="snackbar.show = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
import Api from '@/services/Api'
import 'vue-croppa/dist/vue-croppa.css'
import { mask } from 'vue-the-mask'
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from 'tiptap-vuetify'

export default {
  name: 'client',

  components: { TiptapVuetify },

  directives: {
    mask,
  },

  data() {
    return {
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
      // starting editor's content
      content: `
        <h1>Yay Headlines!</h1>
        <p>All these <strong>cool tags</strong> are working now.</p>
      `,
      item: {},
      croppa: {},
      croppa1: {},
      editedItem: this.item,
      height: 0,
      initialImage: null,
      initialSign: null,
      mask: {
        phone: '(###) ###-####',
        state: 'AA',
        zip: '#####',
      },
      snackbar: {
        show: false,
        color: '',
        message: '',
      },
    }
  },

  created() {
    this.item = this.$store.state.client
    this.loadItem()
  },

  mounted() {
    this.onResize()
  },

  computed: {
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$emit('close', 'the test')
        }
      },
    },
  },

  methods: {
    onResize() {
      this.height = window.innerHeight - 180
    },

    loadItem() {
      this.editedItem = this.item

      let image = new Image()
      image.setAttribute('crossorigin', 'anonymous')
      image.src = this.editedItem.picture

      this.initialImage = image

      let sign = new Image()
      sign.setAttribute('crossorigin', 'anonymous')
      sign.src = this.editedItem.sign

      this.initialSign = sign
    },

    async save() {
      this.editedItem.dataUrl = this.croppa.generateDataUrl('image/png', 0.8)
      this.editedItem.dataUrl1 = this.croppa1.generateDataUrl('image/png', 0.8)

      try {
        const response = await Api().put(
          'clients/' + this.editedItem.id,
          this.editedItem
        )
        this.$store.dispatch('setClient', this.editedItem)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },
  },
}
</script>

<style>
.centered-input input {
  text-align: center;
}

.croppa-container {
  background-color: white;
  border: 3px solid black;
}

.scroll-here {
  overflow: auto;
  height: 340px;
  width: 100%;
}
</style>
